import { createMarkup, uniNewcomerHtml } from '@utils';
import { HtmlGenerator } from '@utils';
import { useSelector } from 'react-redux';
import { currentSubmissionOriginSections, rendererDataSelector } from '@selectors/submission';
import isEmpty from 'lodash/isEmpty';

export const TemplateContainer = (props) => {
  const { env } = props;
  const originSections = useSelector(currentSubmissionOriginSections);

  const formRenderer = useSelector(rendererDataSelector);
  const rendererData = !isEmpty(originSections) ? uniNewcomerHtml : formRenderer;
  const html = new HtmlGenerator(rendererData, env, false, originSections).getHtml();

  return <>{rendererData && <div dangerouslySetInnerHTML={createMarkup(html)} />}</>;
};
